/* eslint-disable import/order */
import React from 'react';
import { AuthenticationCheck } from '@jira/spa-apps__common/src/AuthenticationCheck.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { piEditIssueEmbedRoute } from '@jira/router-routes__product-integrations-routes/src/piEditIssueEmbedRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import type { EditIssueEmbed } from '@jira/growth__gmail-embed/src/ui/edit-issue/index.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyPIEditIssueEmbed = lazyForPaint<typeof EditIssueEmbed>(
	() =>
		import(
			/* webpackChunkName: "async-pi-issue-edit-embed", jiraSpaEntry: "async-pi-issue-edit-embed" */ '@jira/growth__gmail-embed/src/ui/edit-issue/index.tsx'
		).then((module) => module.EditIssueEmbed),
	{ ssr: false },
);

const PIIssueEditEmbedLazy = () => {
	return (
		<AuthenticationCheck>
			<LazyPage
				Page={LazyPIEditIssueEmbed}
				pageId="spa-apps/pi-issue-edit-embed"
				shouldShowSpinner
			/>
		</AuthenticationCheck>
	);
};

export const piEditIssueEmbedRouteEntry: Route = createEntry(piEditIssueEmbedRoute, () => ({
	group: 'issue',
	// eslint-disable-next-line no-restricted-syntax
	component: PIIssueEditEmbedLazy,
	resources: [...jiraSpaResources()],
	layout: chromelessLayout,
	forPaint: [LazyPIEditIssueEmbed],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
